import RewardSource from "@/api/RewardSource.js";

export const rewardModule = {
    state: () => ({
        error: false,
        isLoader: false,
        available: 0,
        can_use: 0,
        applied: null,
    }),
    mutations: {

        setError(state, data) {
            state.error = data;
        },
        setLoader(state, value) {
            state.isLoader = value;
        },
        SET_REWARD(state, value) {
            state.available = value?.available ?? 0;
            state.can_use = value?.can_use ?? 0;
            state.applied = value?.applied ?? null;
        },
    },
    actions: {
        async loadAvailable({commit, state}) {
            commit('setLoader', true);
            await  this.$API.manager.getSource(RewardSource).available().then((response) => {
                state.available = response?.available ?? 0;
                state.can_use = response?.can_use ?? 0;
                state.applied = response?.applied ?? null;
            }).catch(() => {
                state.available = 0;
                state.can_use = 0;
                state.applied = null;
            }).finally(() => {
                commit('setLoader', false);
            })
        },
        setReward({commit}, value) {
            commit('SET_REWARD', value);
        },
        async initReward({commit, dispatch}, value) {
            commit('setLoader', true);
            commit('setError', null);
            await  this.$API.manager.getSource(RewardSource).setReward({ reward: value }).then((response) => {
            }).catch((error) => {
                if(error?.response?.data?.error){
                    commit('setError', error?.response?.data?.error);
                }
            }).finally(() => {
                commit('setLoader', false);
                dispatch('cart/load', null, {root: true});
            })
        },
        async removeReward({commit, dispatch}) {
            commit('setLoader', true);
            commit('setError', null);
            await  this.$API.manager.getSource(RewardSource).remove().finally(() => {
            }).finally(() => {
                commit('setLoader', false);
                dispatch('cart/load', null, {root: true});
            })
        }
    },
    namespaced: true
}
